import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const MoveRightIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M18.5 12L4.99997 12" stroke="currentColor"></path>
      <path d="M13 18C13 18 19 13.5811 19 12C19 10.4188 13 6 13 6" stroke="currentColor"></path>
    </SvgIcon>
  )
}
